export const POS_STAFF_OPTIONS = [
  {
    uuid: 'all',
    name: 'All',
  },
  {
    uuid: 'active',
    name: 'Active',
  },
  {
    uuid: 'inactive',
    name: 'Inactive',
  },
]

export const POS_ROLES = [
  {
    uuid: 'all-roles',
    name: 'All Roles',
  },
  {
    uuid: 'manager',
    name: 'Manager',
  },
  {
    uuid: 'cashier',
    name: 'Cashier',
  },
]
